import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import escImage from './Pictures/fleet/escalade.png';
import benzImage from './Pictures/fleet/benz-s550.png';
import sprinterImage from './Pictures/fleet/sprinterImg.png';
import busImage from './Pictures/fleet/busImg.jpg';
import volvoImage from './Pictures/fleet/volvoImg.jpg';
import { FaSuitcase, FaUserFriends } from 'react-icons/fa';

const Fleet = () => {
  const vehicles = [
    { name: "Cadillac Escalade", capacity: 6, class: "We offer Late-model Cadillac Escalades", img: escImage },
    { name: "Sprinter", capacity: 14, class: "Executive jet sprinters: 9-14 Passengers", img: sprinterImage },
    { name: "Mercedes-Benz S Class", capacity: 3, class: "First Class sedan", img: benzImage },
    { name: "Business Sedan", capacity: 3, class: "We offer late-models", img: volvoImage },
    { name: "Bus", capacity: 24, class: "We offer up to 24 Passenger Buses", img: busImage },
  ];

  return (
    <div className="fleet-slider-container relative">
      <h2 className="text-3xl font-extrabold mb-6 text-center">Our Fleet</h2>
      <div className="fleet-slider-wrapper">
        <Swiper
          className="swiper-container"
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          breakpoints={{
            640: { slidesPerView: 1, spaceBetween: 10 },
            768: { slidesPerView: 2, spaceBetween: 10 },
            1000: { slidesPerView: 3, spaceBetween: 15 }, // New breakpoint for 1000px to 1300px
            1300: { slidesPerView: 4, spaceBetween: 15 }, // Adjusted to show 4 slides per view for 1300px and above
          }}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
          pagination={{ clickable: true }}
          speed={2000} // Adjust the speed here (1000ms = 1s)
        >
          {vehicles.map((vehicle, index) => (
            <SwiperSlide key={index}>
              <div className="vehicle-card flex flex-col items-center w-[14rem] h-[20rem] bg-white rounded-lg shadow-lg p-4 mx-auto text-center"> {/* Added text-center */}
                <img src={vehicle.img} alt={`${vehicle.name} image`} className="w-full h-[10rem] rounded-t-lg" style={{ objectFit: 'contain' }} />
                <h3 className="text-lg font-bold mt-4">{vehicle.name}</h3>
                <p className="text-gray-700">{vehicle.class}</p>
                <div className="flex items-center justify-center text-gray-700 mt-auto mb-4"> {/* Added justify-center */}
                  <FaSuitcase className="mr-2" /> {vehicle.capacity}
                  <FaUserFriends className="ml-4 mr-2" /> {vehicle.capacity}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
      </div>
    </div>
  );
};

export default Fleet;
